import axios from './axiosConfig'

export interface JournalEntry {
  id: string;
  roomName: string | null;
  content: any;
  originalData?: any;
  createdAt: string;
}

export const getJournalEntries = async (limit?: number): Promise<JournalEntry[]> => {
  const response = await axios.get('/journal', {
    params: limit ? { limit } : undefined,
  })
  return response.data
}

export const deleteJournalEntry = async (entryId: string): Promise<void> => {
  await axios.delete(`/journal/${entryId}`)
}

export const updateJournalEntry = async (entryId: string, content: any): Promise<JournalEntry> => {
  const response = await axios.put(`/journal/${entryId}`, { content })
  return response.data
}

export const createJournalEntry = async (data: {
  cards: { name: string; imagePath: string; position: string; isReversed: boolean; keywords?: string[] }[];
  query: string;
  deckName?: string;
}): Promise<JournalEntry> => {
  const response = await axios.post('/journal', data)
  return response.data
}

export const interpretJournalEntry = async (entryId: string): Promise<JournalEntry> => {
  const response = await axios.post(`/journal/${entryId}/interpret`)
  return response.data
}

export const saveSpreadToJournal = async (dailySpreadResultId: string): Promise<JournalEntry> => {
  const response = await axios.post('/journal/from-spread', { dailySpreadResultId })
  return response.data
}
